var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-search',{attrs:{"columns":_vm.searchColumn},on:{"search":_vm.handleSearch}},[(!_vm.typeOfView)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleExport}},[_vm._v("导出")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }